import React from 'react';
import eduDescriptionOne from '../../../assets/img/event-details-imgs/description/ed-descriptionimg1.png';
import eduDescriptionTwo from '../../../assets/img/event-details-imgs/description/ed-descriptionimg2.png';
import eduDescriptionThree from '../../../assets/img/event-details-imgs/description/ed-descriptionimg3.png';
import eduDescriptionFour from '../../../assets/img/event-details-imgs/description/ed-descriptionimg4.png';
import eduDescriptionFive from '../../../assets/img/event-details-imgs/description/ed-descriptionimg5.png';
const EventDetailsDescription = () => {
    return (
        <div className="row mb-4">
            <div className="col-12">
                <div className="w-100 px-4 py-3 description-design">
                    <div className="row mb-3">
                        <div className="col-12 d-flex justify-content-between align-items-center">
                            <span className="bd_username">Description</span>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-12">
                            <p className="ed_des mb-0">„Gucci“ – visame pasaulyje dominuojantis prekės ženklas, bet dar negirdėta jo šeimos istorija, kurioje slypi melas, išdavystė, kerštas ir žmogžudystė. Buvusi Maurizio Gucci žmona, Patrizia Reggiani, buvo apkaltinta
                                savo vyro žmogžudystės užsaky mu po to, kai buvo palikta dėl</p>
                        </div>
                    </div>
                    <div className="row mb-2 gy-lg-2 gy-2">
                        <div className="col-12 col-md-6 col-lg-4">
                            <img className="w-100 image-decoration" src={eduDescriptionOne} alt='' />
                        </div>
                        <div className="col-12 col-md-6 col-lg-4">
                            <img className="w-100 image-decoration" src={eduDescriptionTwo} alt='' />
                        </div>
                        <div className="col-12 col-md-6 col-lg-4">
                            <img className="w-100 image-decoration" src={eduDescriptionThree} alt='' />
                        </div>
                        <div className="col-12 col-md-6 col-lg-4">
                            <img className="w-100 image-decoration" src={eduDescriptionFour} alt='' />
                        </div>
                        <div className="col-12 col-md-6 col-lg-4">
                            <img className="w-100 image-decoration" src={eduDescriptionFive} alt='' />
                        </div>
                        <div className="col-12 col-md-6 col-lg-4"></div>
                    </div>
                </div>
            </div>
        </div>
    
    );
};

export default EventDetailsDescription;